module.exports = __webpack_public_path__ + "static/img/highlight_screen.465b75c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oneMachine/highlight_screen.png
// module id = U8LF
// module chunks = 0